import { FC } from "react";
import { Col, Form, Row } from "react-bootstrap";

const MONTH_LABELS = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];

interface Props {
  month: number;
  year: number;
  onMonthChange: (month: number) => void;
  onYearChange: (year: number) => void;
}

const DashboardMonthYearFilter: FC<Props> = ({
  month,
  year,
  onMonthChange,
  onYearChange,
}) => (
  <Row className="mb-3 justify-content-end">
    <Col md={3}>
      <Form.Label className="mb-1 fs--1">Mois</Form.Label>
      <Form.Select
        value={month}
        onChange={(e) => onMonthChange(Number(e.target.value))}
      >
        {MONTH_LABELS.map((label, index) => (
          <option key={label} value={index + 1}>
            {label}
          </option>
        ))}
      </Form.Select>
    </Col>
    <Col md={3}>
      <Form.Label className="mb-1 fs--1">Année</Form.Label>
      <Form.Control
        type="number"
        value={year}
        onChange={(e) => onYearChange(Number(e.target.value))}
      />
    </Col>
  </Row>
);

export default DashboardMonthYearFilter;
